import React from 'react';
import { ViewPage } from '@atlassian/embedded-confluence';
import { type PageDialogProps } from '../types';
import { useIntl } from 'react-intl-next';

export const ViewPageDialog = ({
	contentId,
	spaceKey,
	parentProduct,
	navigationPolicy,
	accountId,
	themeState,
}: PageDialogProps) => {
	const { locale } = useIntl();

	return (
		<ViewPage
			locale={locale}
			data-testid="embedded-confluence-view-page-dialog"
			contentId={contentId}
			parentProduct={parentProduct}
			spaceKey={spaceKey}
			navigationPolicy={navigationPolicy}
			allowedFeatures={[
				'byline-contributors',
				'byline-extensions',
				'page-comments',
				'edit',
				'delete',
				'page-reactions',
				'inline-comments',
				'non-licensed-share',
			]}
			hasFooterLogo={false}
			userInfo={{
				userId: accountId,
				userIdType: 'atlassianAccount',
			}}
			themeState={themeState}
			isFullScreenEmbedView={true}
		/>
	);
};
